module.exports = __webpack_public_path__ + "img/bp_button_pre_hdgz.1df7d88c.png";